<template>
  <v-app id="app">
    <v-navigation-drawer v-if="user"
      v-model="drawer"
      fixed
      app
    >
      <v-list dense>

          <v-list-tile @click="$router.replace('/')">
            <v-list-tile-action>
              <v-icon>home</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Home</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>


          <v-list-tile @click="$router.replace('/admin')">
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Admin</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile @click="logout">
            <v-list-tile-action>
              <v-icon>exit_to_app</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Sign out</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

      </v-list>
    </v-navigation-drawer>
    <v-toolbar v-if="user" color="blue-grey darken-2" dark fixed app>
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>Fiction Tribe Client Portal</v-toolbar-title>
    </v-toolbar>
    <v-content>
      <v-container>
        <v-layout
        >
            <router-view :key="$route.fullPath"/>

        </v-layout>
      </v-container>
    </v-content>
    <v-footer v-if="user" color="blue-grey darken-2" app>
      <span class="white--text">Fiction Tribe &copy; 2019</span>
    </v-footer>
  </v-app>
</template>

<script>
import firebase from 'firebase'
import db from './main.js'
import {store} from './store/store.js'
import Vuex from 'vuex'

export default {
  name: 'app',
  store: store,
  components: {

  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    isAdmin() {
      return this.$store.getters.getAdmin;
    }
  },
  methods: {
    logout: function() {
      firebase.auth().signOut().then(() => {
        this.$store.dispatch('setUser')
        this.$router.replace('login')
      })
    }
  },
  data () {
    return {
      drawer: false
    }
  },
  beforeCreate () {
    var self = this;
    setTimeout(function() {
      console.log("Mounted: " + self.isAdmin)
      console.log("Mounted: " + self.user)
    }, 3000)
  },
  mounted() {
    this.$store.dispatch('setUser');
    function hasTouch() {
    return 'ontouchstart' in document.documentElement
           || navigator.maxTouchPoints > 0
           || navigator.msMaxTouchPoints > 0;
    }
  }
}
</script>

<style>
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
}
body {
    background-color: #fafafa;
}
img#logo {
    width: 120px;
    margin-bottom: 20px;
}
</style>
